module.exports = __webpack_public_path__ + "static/media/student-end-season-star.e31abd37.png";